import type { FC } from 'react';
import type { ButtonBackground } from 'components/Button';

import { PackButtonStyled } from './styled';
import type { IPackButton } from './types';

const PackButton: FC<IPackButton> = ({
  total,
  isSaleFinished,
  onClick,
  'data-test-id': dataTestId,
}) => {
  let disabled: boolean = false;
  let buttonType: ButtonBackground = 'primary';
  let isSoldTitle = 'buy';
  if (total === 0) {
    disabled = true;
    isSoldTitle = 'sold out';
    buttonType = 'lightGray';
  } else if (isSaleFinished) {
    disabled = true;
    isSoldTitle = 'sale ended';
    buttonType = 'lightGray';
  }

  return (
    <PackButtonStyled
      size="small"
      disabled={disabled}
      background={buttonType}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      {isSoldTitle}
    </PackButtonStyled>
  );
};

export default PackButton;
